import Vuex from "vuex";
import menu from "./modules/menu";
import services from "./modules/services";
import modals from "./modules/modals";
import simcards from "./modules/simcards";
export default new Vuex.Store({
  namespaced: true,
  modules: {
    menu,
    services,
    modals,
    simcards,
  },
  state: {},
  mutations: {},
  actions: {},
  getters: {}
});
